import React, { useState, useEffect } from 'react';
import { makeStyles, useTheme } from 'utils/makeStylesAdapter';
import { IconButton, Button, useMediaQuery } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import ChatIcon from '@mui/icons-material/Chat';
import colorsSteps from 'utils/colorsSteps';

const useStyles = makeStyles(theme => ({
  root: {
    height: 50,
    width: 50,
    backgroundColor: colorsSteps.ANALISE,
    '&:hover': {
      backgroundColor: colorsSteps.ANALISE,
    },
    padding: theme.spacing(1),
    margin: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(0.3),
    },
  },
  root2: {
    backgroundColor: colorsSteps.ANALISE,
    '&:hover': {
      backgroundColor: colorsSteps.ANALISE,
    },
    color: '#fff',
    borderRadius: 25,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  icon: {
    color: '#fff',
  },
  container: {
    margin: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0.3),
      width: '100%',
    },
  },
}));

const ButtonChat = props => {
  const { onClick, className, ...rest } = props;

  const classes = useStyles();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [fullBtn, setFullBtn] = useState(false);

  useEffect(() => {
    if (fullScreen) {
      setFullBtn(true);
    } else {
      setFullBtn(false);
    }
  }, [fullScreen]);

  if (fullBtn) {
    return (
      <div className={classes.container}>
        <Button
          {...rest}
          className={classes.root2}
          variant="contained"
          size="large"
          onClick={onClick}
        >
          <ChatIcon className={classes.icon} />
        </Button>
      </div>
    );
  } else {
    return (
      <IconButton {...rest} className={clsx(classes.root, className)} onClick={onClick}>
        <ChatIcon className={classes.icon} />
      </IconButton>
    );
  }
};

ButtonChat.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default ButtonChat;
